import React from 'react'
import { Form, Input, Select } from 'antd'
import { DocumentUpload } from '../../../../components/DocumentUpload'

const { Option } = Select

export const BankDetailsStep: React.FC = () => {
    return (
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <Form.Item
                label="Account Holder Name"
                name="account_holder_name"
                rules={[{ required: true, message: 'Please enter account holder name' }]}
            >
                <Input placeholder="As per bank records" />
            </Form.Item>

            <Form.Item
                label="Bank Name"
                name="bank_name"
                rules={[{ required: true, message: 'Please enter bank name' }]}
            >
                <Input placeholder="e.g., HDFC Bank, ICICI Bank" />
            </Form.Item>

            <Form.Item
                label="Account Number"
                name="account_number"
                rules={[{ required: true, message: 'Please enter account number' }]}
            >
                <Input placeholder="Enter account number" />
            </Form.Item>

            <Form.Item
                label="IFSC Code"
                name="ifsc_code"
                rules={[
                    { required: true, message: 'Please enter IFSC code' },
                    { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: 'Invalid IFSC format' }
                ]}
            >
                <Input placeholder="HDFC0001234" style={{ textTransform: 'uppercase' }} maxLength={11} />
            </Form.Item>

            <Form.Item
                label="Account Type"
                name="account_type"
                rules={[{ required: true, message: 'Please select account type' }]}
            >
                <Select placeholder="Select Account Type">
                    <Option value="current">Current</Option>
                    <Option value="savings">Savings</Option>
                </Select>
            </Form.Item>

            <Form.Item
                label="Cancelled Cheque / Passbook Image"
                name="cheque_image"
                rules={[{ required: true, message: 'Please upload cancelled cheque or passbook image' }]}
            >
                <DocumentUpload documentType="cancelled_cheque" />
            </Form.Item>
        </div>
    )
}
